// extracted by mini-css-extract-plugin
module.exports = {"nums":"Pagination_nums_3o18d","num":"Pagination_num_1MPfO","active":"Pagination_active_DoRiR","arrow":"Pagination_arrow_2FTqw"};